import { installThemeColour } from "@groundspark/styles/colours";
import "@groundspark/styles/admin";
import { AdminApplication } from "./app";
import { AuthManager } from "./auth";
import { readConfig } from "./config";

installThemeColour(document);

const root = document.querySelector<HTMLElement>("#app");
if (root === null) throw new Error("The administration root element is missing.");

try {
  const application = new AdminApplication(root, new AuthManager(readConfig()));
  await application.start();
} catch (error) {
  root.replaceChildren(fatalError(error));
}

function fatalError(error: unknown): HTMLElement {
  const main = document.createElement("main");
  main.className = "centred-screen";
  const section = document.createElement("section");
  section.className = "message-card";
  const title = document.createElement("h1");
  title.className = "message-card__title";
  title.textContent = "Administration could not start";
  const message = document.createElement("p");
  message.className = "muted";
  message.textContent = error instanceof Error ? error.message : String(error);
  section.append(title, message);
  main.append(section);
  return main;
}
